import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import {PROTOCOLS} from "../../util/Validations";
import {TESSERACT_ASSET_TYPE} from "../../util/Constants";
import CommonDeviceLogstream from "../../commonui/CommonDeviceLogstream";
import {TesseractDeviceOverviewContext} from "./context/TesseractDeviceOverviewContext";

const TesseractDeviceLogstream = ({intl}) => {

    const {viewModel, dispatch} = useContext(TesseractDeviceOverviewContext);
    const deviceList = Object.values(viewModel.tesseractDeviceInformation);

    const props = {
        protocols: PROTOCOLS.TESSERACT,
        dispatch,
        deviceList,
        deviceType: TESSERACT_ASSET_TYPE,
        intl
    }
    return (
        <Column>
            <CommonDeviceLogstream {...props}/>
        </Column>
    );
}

export default injectIntl(TesseractDeviceLogstream)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/tesseract/TesseractDeviceLogstream.js